import React, { useRef } from 'react';

import ToggleOptionTitle from '@/components/common/ToggleOption/ToggleOptionTitle';
import DaysCount from './DaysCount';
import DaysForm from './DaysForm';
import styles from './custom-toggle.module.scss';

interface ICustomToggleTitleComponentProps {
  title: string;
  isEnabled: boolean;
  isVisibleForm: boolean;
  setIsVisibleForm: React.Dispatch<React.SetStateAction<boolean>>
  disableToggle: () => void;
  handleSubmit: (days: number | null) => void;
  days?: number | null;
  isLoading: boolean;
}

export default function CustomToggleTitleComponent(props: ICustomToggleTitleComponentProps) {
  const { title, disableToggle, handleSubmit, days, isLoading, isVisibleForm, setIsVisibleForm } = props;
  const rootDivRef = useRef<HTMLDivElement | null>(null);
  const renewalDaysEqualZero = days === 0;

  const isVisibleDaysCount = Boolean((days || renewalDaysEqualZero) && !isVisibleForm && !isLoading);
  const onSubmit = (daysNumber: number | null) => {
    handleSubmit(daysNumber);
    setIsVisibleForm(false);
  };

  const handleClose = () => {
    setIsVisibleForm(false);
    if (!days && days !== 0) {
      disableToggle();
    }
  };

  const onEditDays = () => {
    setIsVisibleForm(true);
  };


  return (
    <div
      ref={rootDivRef}
      className={styles['ag-before-renewal']}
    >
      <ToggleOptionTitle>{title}</ToggleOptionTitle>
      {isVisibleForm && (
        <DaysForm
          onSubmit={onSubmit}
          onClose={handleClose}
          days={days}
        />
      )}
      {isVisibleDaysCount ? (
        <DaysCount
          days={days as number}
          onEditDays={onEditDays}
        />
      ) : null}
    </div>
  );
}
